import Vuex from '@/store/index'
import router from '@/router'
const baseSize = 16
function setRem() {
  Vuex.commit('setWidth',document.body.clientWidth)
  // document.documentElement.style.fontSize = 'initial'//自定义设置响应式不生效，initial为默认16px，可根据需求调节
  if (document.body.clientWidth < 600) {
    const scale = document.documentElement.clientWidth / 375 //手机端
    document.documentElement.style.fontSize = (baseSize * Math.min(scale, 2)) + 'px'
  } else {
    const scale = document.documentElement.clientWidth / 1720 //pc端，可根据需求调整
    document.documentElement.style.fontSize = (baseSize * Math.min(scale, 2)) + 'px'
  }
}
setRem()
window.onresize = () => {
  setRem()
  console.log();
}